// extracted by mini-css-extract-plugin
export default {"Wrapper":"RegistrationPage_Wrapper__B6psb","Logo":"RegistrationPage_Logo__PWAaV"};